import { render, staticRenderFns } from "./WidgetCalendar.vue?vue&type=template&id=7b5ed5f5&scoped=true"
import script from "./WidgetCalendar.vue?vue&type=script&lang=js"
export * from "./WidgetCalendar.vue?vue&type=script&lang=js"
import style0 from "./WidgetCalendar.vue?vue&type=style&index=0&id=7b5ed5f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5ed5f5",
  null
  
)

export default component.exports